var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"flex flex-col door-seller-profile"},[_c('h4',[_vm._v("Seller Profile")]),_vm._v(" "),_c('div',{staticClass:"flex justify-between"},[_c('div',{staticClass:"flex flex-col"},[_c('span',[_vm._v(_vm._s(_vm.user.name))]),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.user.email))])])])])
}
var staticRenderFns = []

export { render, staticRenderFns }


// WEBPACK FOOTER //
// ./Features/Shared/VueComponents/DoorSales/Components/door-seller-profile.vue?vue&type=template&id=0b24e91b&